import styled from 'styled-components';
import { ASSETS } from '../../../utils/config';
export const Dropdown = styled.div`
  position: absolute;
  width: 30vw;
  top: 10vh;
  right: 20px;
  box-shadow: 0px 4px 7px 0px #00000014;
  border-radius: 8px;
  z-index: 9999;
  border: 1px solid white;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-color: white;
`;

export const NotificationWrapper = styled.div`
  height: 50vh;
  overflow-y: auto;
  width: 100%;

  /* Hide scrollbar for modern browsers */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  gap: 10px; /* Adds spacing between buttons */
  align-items: center;

  button {
    width: auto; /* Ensure width adapts to text content */
    padding-left: 12px;
    padding-right: 12px;
  }
`;

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between; /* Space between left and right parts */
  padding: 16px;
  background-color: white;
  width: 30vw; /* Same width as the container */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
`;
